var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-9',[_c('h2',{staticClass:"title"},[_vm._v("最新告警信息")]),_c('div',{staticClass:"warning-wrapper"},[_c('dv-scroll-board',{staticStyle:{"width":"600px","height":"300px","padding":"0 8px"},attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }